// extracted by mini-css-extract-plugin
export default {"policy":"Z753E5Y3","preHeader":"ea1lkA8m","nowrap":"BpgxRrHb"};